<form novalidate #currentForm="ngForm" class="advance_tab_container">
  <div class="row">
    <span>Configuration</span>
    <div class="configuration_container">
      <div
        class="PM_Interval"
        *ngIf="showFormField(configMapping.PM_INTERVAL) && isPmReterivalEnabled"
      >
        <label>PM Report Interval</label>
        <mat-select
          class="option-list"
          #pmIntervalInput="ngModel"
          name="pmIntervalInput"
          [(ngModel)]="formField.pmInterval"
          (ngModelChange)="onPMIntervalChange()"
          [disabled]="esamPMInterval"
        >
          <ng-container *ngFor="let item of pmIntervalDropdown">
            <mat-option [value]="item.id">{{ item.value }}</mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="keep-alive">
        <label
          >Keep Alive
          <i class="mdi mdi-help-circle-outline" matTooltip="{{ formTooltip.keepAlive }}"></i
        ></label>
        <mat-select
          class="option-list"
          #keepAliveInput="ngModel"
          name="keepAliveInput"
          [(ngModel)]="formField.keepAlive"
          (ngModelChange)="onKeepAliveChange()"
        >
          <mat-option *ngFor="let selection of confirmSelection" [value]="selection.value">{{
            selection.name
          }}</mat-option>
        </mat-select>
      </div>
      <div class="keep-alive" *ngIf="showFormField(configMapping.REBOOT)">
        <label>Persist after Reboot </label>
        <mat-select
          class="option-list"
          #rebootInput="ngModel"
          name="rebootInput"
          [(ngModel)]="formField.reboot"
          (ngModelChange)="onRebootChange()"
        >
          <mat-option *ngFor="let selection of confirmSelection" [value]="selection.value">{{
            selection.name
          }}</mat-option>
        </mat-select>
      </div>
      <div class="percentile" *ngIf="showFormField(configMapping.ENABLE_PERCENTILES)">
        <label
          >Calculate Percentiles<i
            class="mdi mdi-help-circle-outline"
            matTooltip="{{ formTooltip.percentiles }}"
          ></i
        ></label>
        <mat-select
          class="option-list"
          #percentInput="ngModel"
          name="percentInput"
          [(ngModel)]="formField.percentiles"
          (ngModelChange)="onCalculatePercentilesChange()"
        >
          <mat-option *ngFor="let selection of confirmSelection" [value]="selection.value">{{
            selection.name
          }}</mat-option>
        </mat-select>
      </div>
      <div *ngIf="showFormField(configMapping.CODEC)">
        <label
          >MOS Codec Analysis<i
            class="mdi mdi-help-circle-outline"
            matTooltip="{{ formTooltip.codec }}"
          ></i
        ></label>
        <mat-select
          class="option-list"
          #codecInput="ngModel"
          name="codecInput"
          [(ngModel)]="formField.codecVal"
          (ngModelChange)="onCodecChange()"
          [disabled]="disableCodec()"
        >
          <mat-option [value]="item.id" *ngFor="let item of mosCodeConfig">{{
            item.value
          }}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="row default_conatiner" *ngIf="selectedIndex === 0">
    <span>Defaults</span>
    <div class="refelctor_udp_port">
      <label
        >Reflector UDP port<i
          class="mdi mdi-help-circle-outline"
          matTooltip="{{ formTooltip.reflectorUdpPort }}"
        ></i
      ></label>
      <input
        matInput
        type="number"
        class="reflector_input"
        #udpPortInput="ngModel"
        name="udpPortInput"
        [(ngModel)]="formField.udpPort"
        required
        min="1"
        max="65535"
        (ngModelChange)="onReflectorUDPChange()"
      />
      <div
        class="error"
        *ngIf="udpPortInput.invalid && (udpPortInput.dirty || udpPortInput.touched)"
      >
        <mat-error *ngIf="udpPortInput.errors.required">UDP port is required</mat-error>
        <mat-error *ngIf="udpPortInput.errors.min || udpPortInput.errors.max"
          >Valid range 1 and 65535</mat-error
        >
      </div>
      <div class="reflector_message">Default for each reflector that has no port defined</div>
    </div>
  </div>
  <div class="row flow_configuration_container">
    <span class="flows">Flows</span>
    <mat-tab-group
      #tabgroup
      animationDuration="0"
      mat-align-tabs="start"
      (selectedTabChange)="onFlowTabChange($event.index)"
      [(selectedIndex)]="selectedIndex"
    >
      <mat-tab label="Common flows">
        <div class="flows-list">
          <nrwl-common-flow-list
            [dataSource]="commonFlows"
            [displayedColumns]="commonFlowsColumns"
            [mosCodecValue]="formField.codecVal"
            [vlanId]="vlanId"
            [ipAddressType]="ipAddressType"
            [txInterval]="txIntervalDropdown"
            [dfBitDisabled]="isDfBitDisabled"
            [selectedDeviceIndex]="selectedDeviceIndex"
            (sendFlowList)="updateCommonFlows($event)"
          ></nrwl-common-flow-list>
        </div>
      </mat-tab>
      <mat-tab label="Specific flows" [disabled]="!this.selectedDeviceId">
        <div class="select-device">
          <viavi-common-dropdown
            [dropDownData]="deviceDropDownData"
            [configuration]="dropdownConfiguration"
            (valueChange)="deviceSelection($event)"
            [defaultSelection]="selectedDevice"
            [isCustomDropdown]="true"
          ></viavi-common-dropdown>
        </div>
        <div class="flows-list">
          <nrwl-common-flow-list
            [displayedColumns]="specificFlowsColumns"
            [dataSource]="specificAgentFlows"
            [mosCodecValue]="formField.codecVal"
            [vlanId]="vlanId"
            [availableFlowNames]="availableFlowNames"
            [txInterval]="txIntervalDropdown"
            [dfBitDisabled]="isDfBitDisabled"
            [selectedDeviceIndex]="selectedDeviceIndex"
            (sendFlowList)="updateSpecificFlows($event)"
          ></nrwl-common-flow-list>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</form>
